<template>
  <div id="app">

    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      la_id: "",
      nowurl: "",
    };
  },
  created() {
    this.linktab();
  },
  methods: {
    linktab() {
      let goUrl = this.isMobile();
      console.log('999999',goUrl)
      if (goUrl == 1) {
        //移动端地址
        location = "http://wap.kxwg123.com/";
      } else {
        //PC地址
        // location = "http://www.kxwg123.com/";
      }
    },
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      let goUrl = flag ? 1 : 0;
      return goUrl;
    },
  },
}
</script>

<style>
.el-textarea__inner{
  min-height: 180px !important;
}
.el-menu--horizontal(1){
  left: 725 !important;
}
.titimgh{

}
.titimgh{
  cursor: pointer;
  transition: all 0.6s;

}
.titimgh:hover{
  cursor: pointer;
  transform: scale(1.2);

}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #DF584D !important;
  color: #FFF;
}
.swiper-slide div{
}
.el-menu-item-group__title {
  margin-top: -10px !important;
}
.title_fu {
  font-size: 18px;
  font-family: PingFang;
  font-weight: 500;
  color: #666666;
  margin-bottom: 0px !important;
}
.swiper-slide{
  //width: 300px !important;
  //margin-right: 30px !important;
  //height: 420px !important;
}
.swiper-container{
  height: 420px !important;
  //padding-left: 75px;
}
*{
  margin: 0px;
  padding: 0px;

}
html,body{
  margin: 0px;
  padding: 0px;
  height: 100%;
  width: 100%;
  background: #F8F8F8;
  color: #333333;
}
/*.box{*/
/*  position: absolute;*/
/*  margin: 0px;*/
/*  padding: 0px;*/
/*  width: 100%;*/
/*  height: 100%;*/
/*}*/
.content{
  position: absolute;
  /*border: 1px solid red;*/
  width: 63%;
  height: 100%;
  left: 0; top: 0; right: 0; bottom: 0;
  margin: auto;    /* 有了这个就自动居中了 */
}
.el-table td, .el-table th {
  padding: 11px 0;
  min-width: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-overflow: ellipsis;
  vertical-align: middle;
  position: relative;
  text-align: left;
}

.el-button {
  padding: 10px 11px;

}
.table{
  width: 100%;
  /*height: 707px;*/
  background: #FFFFFF;
  box-shadow: 0px 0px 12px 0px rgba(224, 224, 224, 0.5);
  border-radius: 4px;

}
/deep/.el-table thead {
  color: #333333!important;
  font-weight: 500;
}
.el-table {
  color: #333333!important;
}
.tips{
  margin: 16px;
}
.proTitel{
  font-size: 16px;
  color: #333333;
  margin-left: 8px;
}
.line{
  width: 4px;
  height: 20px;
  background: #3F87EA;
}
.titel{
  font-size: 18px;
  font-weight: 600;
  color: #333333;
  margin-left:8px ;
}
.titel-box{
  margin-bottom: 16px;
  display: flex;
  align-items: center;
}
html, body, div, span, applet, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
a, abbr, acronym, address, big, cite, code,
del, dfn, em, font, img, ins, kbd, q, s, samp,
small, strike, strong, sub, sup, tt, var,
b, u, i, center,
dl, dt, dd, ol, ul, li,
fieldset, form, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td {
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
  font-size: 100%;
  /*background: transparent;*/
}
table {
  border-collapse:collapse;
  border-spacing:0;
}
fieldset, img {    border:0;}
address, caption, cite, code, dfn, em, strong, th, var {
  font-style:normal;
  font-weight:normal;
}
ol, ul { list-style:none; }
caption, th { text-align:left; }
h1, h2, h3, h4, h5, h6 {
  font-size:200%;
  font-weight:normal;
}
:focus { outline: 0;}
a{ text-decoration:none;}
a:hover img{ border:none;}

a:active{noOutline:expression(this.onFocus=this.blur());}
/*清除浮动*/
.clearfix:after {
  content: ".";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.clearfix {display: inline-block;}
/* Hides from IE-mac \*/
* html .clearfix { height: 1%;}
.clearfix {display: block;}
/* End hide from IE-mac */

.el-submenu__title {
  font-size: 20px !important;
  color: #303133;
  padding: 0 20px;
  cursor: pointer;
  -webkit-transition: border-color .3s,background-color .3s,color .3s;
  transition: border-color .3s,background-color .3s,color .3s;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
html { overflow-x: hidden; }
.el-menu--collapse .el-menu .el-submenu, .el-menu--popup {
  min-width: 120px !important;
}
.swiper-slide{
  background: none !important;
}
.el-menu--horizontal>.el-menu-item.is-active {
  color: #DF584D !important;
  border-bottom: 2px solid #DF584D !important;
}
.el-menu--horizontal>.el-submenu .el-submenu__title {
  line-height: 118px !important;
  border-bottom: 2px solid transparent;
  color: #909399;
}
.el-submenu__icon-arrow {
  display: none !important;
}
.el-menu--popup {
  padding: 0 !important;
}
.el-menu-item-group__title {
  padding: 0px !important;
}
.el-submenu .el-menu-item {
  min-width: 120px !important;
}
.el-menu-item{
  padding: 0 !important;
}
.el-submenu__title {
  padding: 0 !important;
}
.el-menu--popup {
  z-index: 100;
  border: none;
  padding: 5px 0;
  border-radius: 2px;
  -webkit-box-shadow: 0 0px 0px 0 rgb(0 0 0 / 10%) !important;
  box-shadow: 0 0px 0px 0 rgb(0 0 0 / 10%) !important;
}
.el-menu {
  background-color: none ;
}
.el-menu--popup-bottom-start {
  margin-top: 2px;
}
.el-menu-item.is-active {
  color: #DF584D !important;
  border-bottom: 2px solid #DF584D !important;
}
.el-menu--horizontal>.el-submenu.is-active .el-submenu__title {
  border-bottom: 0px solid #409EFF !important;
  color: #303133;
}
.banner .el-carousel__container{
  height: 900px !important;
}
.banner .el-carousel__indicators--outside{
  position: absolute;
  border-bottom: 17px;
  left: 47%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue